import React, { Component } from 'react';
import './css/App.css';
import './css/bootstrap.min.css';
import {
  HashRouter as Router,
  Route,
  Redirect
} from 'react-router-dom';
import Base from './rebase';
import Header from './reusable_components/Header';
import NavigationBar from './reusable_components/NavigationBar';
import Page from './reusable_components/Page';
import Login from './Login.jsx';
import cookie from 'react-cookies';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      topNav: [],
      username: "",
      jwt: "",
      loggedIn: false
    };
    this.logout = this.logout.bind(this);
  }

  fetchPages() {
    this.ref = Base.fetch('pages', {
      context: this,
      asArray: true,
      queries: {
        orderByChild: 'order'
      }
    })
    .then(data => {
      this.setState({
        loggedIn: true,
        topNav: data
      });
    })
    .catch(error => {
      this.setState({
        loggedIn: false
      });
      console.log("App.jsx" + error);
    });
  }

  componentWillMount() {
    this.fetchPages();
  }

  loggedIn(isLoggedIn) {
    this.setState({loggedIn: isLoggedIn});
    if (this.state.loggedIn === true) {
      this.fetchPages();
    }
  }

  logout() {
    this.setState({loggedIn: false});
  }

  render() {
    var page;
    if (this.state.loggedIn) {
      page = (
        <Router>
          <div>
            <Header />
            <NavigationBar />
            <hr/>
            {
              this.state.topNav.map((nav, index) => (
                <Route key={nav.link} path={"/"+nav.link} render={props => <Page page={nav.key} logout={this.logout}/>} />
              ))
            }
            <Route key={"noRoute"} path={"/"} render={props => <Redirect to={"/rsvp"}/>}/>
          </div>
        </Router>
      );
    } else {
      page = (<Login setLogin={(loggedIn) => this.loggedIn(loggedIn)}/>);
    }
    return page;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx